import {all} from "redux-saga/effects";
import {combineReducers} from "redux";

import * as auth from "./reducers/authSlice";
// import * as calendar from "../app/modules/Calendar/_redux/calendar";
// import {fieldSlice} from "../app/modules/Field/_redux/fieldSlice";
import {scheduleSlice} from "./reducers/scheduleSlice";
// import {priceSlice} from "../app/modules/Price/_redux/priceSlice";
// import {serviceSlice} from "../app/modules/Service/_redux/serviceSlice";
// import {planSlice} from "../app/modules/Plan/_redux/planSlice";
// import {clientSlice} from "../app/modules/Client/_redux/clientSlice";
import {branchSlice} from "./reducers/branchSlice";
import {creditCardSlice} from "./reducers/creditCardSlice";
// import {accountSlice} from "../app/modules/Account/_redux/accountSlice";
// import {tagSlice} from "../app/modules/Tag/_redux/tagSlice";
// import {invoiceSlice} from "../app/modules/Invoice/_redux/invoiceSlice";
import {signatureSlice} from "./reducers/signatureSlice";
import {contractSlice} from "./reducers/contractSlice";
import {dayUseSlice} from "./reducers/dayUseSlice";
import {packageSlice} from "./reducers/packageSlice";
import {couponSlice} from "./reducers/couponSlice";
import {creditSlice} from "./reducers/creditSlice";
import {creditPurchaseSlice} from "./reducers/creditPurchaseSlice";
import {profileSlice} from "./reducers/profileSlice";
import {paymentSlice} from "./reducers/paymentSlice";
import {helpCenterSlice} from "./reducers/helpCenterSlice";
import {invoiceSlice} from "./reducers/invoiceSlice";

export const rootReducer = combineReducers({
  auth: auth.reducer,
  // calendar: calendar.reducer,
  // fields: fieldSlice.reducer,
  schedules: scheduleSlice.reducer,
  // prices: priceSlice.reducer,
  // services: serviceSlice.reducer,
  // plans: planSlice.reducer,
  // clients: clientSlice.reducer,
  branches: branchSlice.reducer,
  creditCards: creditCardSlice.reducer,
  // account: accountSlice.reducer,
  // tags: tagSlice.reducer,
  // invoices: invoiceSlice.reducer,
  signatures: signatureSlice.reducer,
  contracts: contractSlice.reducer,
  dayUses: dayUseSlice.reducer,
  packages: packageSlice.reducer,
  coupons: couponSlice.reducer,
  credits: creditSlice.reducer,
  creditPurchases: creditPurchaseSlice.reducer,
  payments: paymentSlice.reducer,
  profile: profileSlice.reducer,
  helpCenter: helpCenterSlice.reducer,
  invoices: invoiceSlice.reducer,
});

export function* rootSaga() {
  yield all([auth.saga()]);
}
